const es = {
    'permission.table.button.create': 'Crear permiso',
    'permission.table.filter_by_sku': 'Filtrar por SKU',
    'permission.table.filter_by_description': 'Filtrar por Descripción',
    'permission.table.filter_by_deleted': 'Filtrar por Eliminado',
    'permission.table.filter_by_deleted_deleted': 'Elimandos',
    'permission.table.filter_by_deleted_not_deleted': 'No Eliminados',
    'permission.table.filter_by_deleted_all': 'Todos',
    'permission.table.title': 'Permisos',
    'permission.table.sku': 'SKU',
    'permission.table.description': 'Descripción',
    'permission.table.actions': 'Acciones',
    'permission.table.modal.delete.title': 'Eliminar',
    'permission.table.modal.delete.done': 'Realizado con éxito',
    'permission.table.modal.delete.phrase': '¿Estás seguro de que quieres eliminar?',
    'permission.table.modal.delete.button.cancel': 'Cancelar',
    'permission.table.modal.delete.button.delete': 'Eliminar',
    'permission.table.modal.restore.title': 'Restaurar',
    'permission.table.modal.restore.done': 'Realizado con éxito',
    'permission.table.modal.restore.phrase': '¿Estás seguro de que quieres restaurar?',
    'permission.table.modal.restore.button.cancel': 'Cancelar',
    'permission.table.modal.restore.button.restore': 'Restaurar',

    'permission.table.category': 'Categoría',
    'permission.table.filter_by_category': 'Filtrar por Categoría',
    'permission.form.update': 'Actualizar permiso',
    'permission.form.create': 'Crear permiso',
    'permission.form.sku': 'SKU',
    'permission.form.description': 'Descripción',
    'permission.form.category': 'Categoría',
    'permission.form.cancel': 'Volver',
};

export default es;